module.exports = __webpack_public_path__ + "img/assess_checklist.d8bcdc9f.svg";